const timerColors = ['#ec1d57', '#ffa402', '#0dbafc'];

const calculateProgress = (seconds: number) => 100 * seconds / 600;

export const calculateTimerColor = (seconds: number) => {
  const progress = calculateProgress(seconds);

  if (progress <= 10) {
    return timerColors[0];
  } else if (progress <= 50) {
    return timerColors[1];
  }

  return timerColors[2];
};

export const toMoney = value => {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(parseInt(value, 10) / 100);
};
